import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
import lodashGet from "lodash/get";

import { nowUtc, getTodayStartEndDate } from "@/common/date.utilities";
import { getKeywordsStringFromBuilder } from "@/services/search/savedSearch.service";

export { _formatSavedSearchParams as formatSavedSearchParams };

const _formatSavedSearchParams = (params) => {
  let _format;
  if (params) {
    _format = {
      search: params.search,
      start: params.start,
      bounds: params.bounds,
      bounds_type: params.boundsType,
      end: params.end ? params.end : getTodayStartEndDate(dayjs(nowUtc)).end,
      time_range: params.time_range ? params.time_range : null,
      places: params.places,
    };
  }
  if (
    lodashGet(params.keywordsBuilder, "includes[0].keywords.length") ||
    lodashGet(params.keywordsBuilder, "excludes.length")
  ) {
    _format.keywordsBuilder = params.keywordsBuilder;
    _format.search = getKeywordsStringFromBuilder(params.keywordsBuilder);
  }
  if (params.aoiId && params.aoiId.length) {
    _format.aoiId = params.aoiId;
  }
  if (params.topics) {
    _format.topics = params.topics.split(",");
  }
  if (params.sources) {
    _format.sources = params.sources.split(",");
  }
  if (params.hotspotsOnly) {
    params.hotspotsOnly =
      params.hotspotsOnly === "true" || params.hotspotsOnly === true;
    _format.hotspotsOnly = params.hotspotsOnly;
  }
  if (params.eventType) {
    _format.eventType = params.eventType;
  }
  if (params.verifiedType) {
    _format.verifiedType = params.verifiedType;
    if (params.verifiedType !== "maritime") {
      if (params.severityMin && !isNaN(params.severityMin)) {
        _format.severityMin = params.severityMin;
      }
      if (params.severityMax && !isNaN(params.severityMax)) {
        _format.severityMax = params.severityMax;
      }
      if (params.sectors) {
        _format.sectors = !Array.isArray(params.sectors)
          ? params.sectors.split(",")
          : params.sectors;
      }
      if (params.assets) {
        _format.assets = !Array.isArray(params.assets)
          ? params.assets.split(",")
          : params.assets;
      }
      if (params.attackTypes) {
        _format.attackTypes = !Array.isArray(params.attackTypes)
          ? params.attackTypes.split(",")
          : params.attackTypes;
      }
      if (params.perpetrators) {
        _format.perpetrators = !Array.isArray(params.perpetrators)
          ? params.perpetrators.split(",")
          : params.perpetrators;
      }
    } else {
      if (params.maritimeSubcategories) {
        _format.maritimeSubcategories = !Array.isArray(
          params.maritimeSubcategories
        )
          ? params.maritimeSubcategories.split(",")
          : params.maritimeSubcategories;
      }
      if (params.maritimeVesselTypes) {
        _format.maritimeVesselTypes = !Array.isArray(params.maritimeVesselTypes)
          ? params.maritimeVesselTypes.split(",")
          : params.maritimeVesselTypes;
      }
    }
  }
  if (params.riskCategories) {
    _format.riskCategories = params.riskCategories.split(",");
  }
  if (params.tags) {
    _format.tags = params.tags.split(",");
  }

  return _format;
};
